var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"box-card order-detail-section mg20"},[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("学校规模")])]),_vm._v(" "),_c('div',[_c('el-row',[_vm._v("\n      班级数："+_vm._s(_vm.order.class_num)+"        教师数："+_vm._s(_vm.order.teacher_num)+"\n    ")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ee7fad3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/partial/order_scale.vue
// module id = 2321
// module chunks = 0